const state = {
  visitedViews: [],
  cachedViews: [],
}

const mutations = {
  ADD_VISITED_VIEW(state, view) {
    if (state.visitedViews.some((v) => v.path === view.path)) return
    state.visitedViews.push({
      path: view.path,
      fullPath: view.fullPath,
      name: view.name,
      title: view.title || '',
      query: view.query || {},
      params: view.params || {},
      affix: view.affix || false,
    })
  },
  ADD_CACHED_VIEW(state, view) {
    if (state.cachedViews.includes(view.name)) return
    if (view.name) {
      state.cachedViews.push(view.name)
    }
  },
  DEL_VISITED_VIEW(state, view) {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews.splice(i, 1)
        break
      }
    }
  },
  DEL_CACHED_VIEW(state, view) {
    const index = state.cachedViews.indexOf(view.name)
    if (index > -1) {
      state.cachedViews.splice(index, 1)
    }
  },
  DEL_OTHERS_VISITED_VIEWS(state, view) {
    state.visitedViews = state.visitedViews.filter(
      (v) => v.path === view.path || v.affix
    )
  },
  DEL_OTHERS_CACHED_VIEWS(state, view) {
    const keepNames = state.visitedViews.map((v) => v.name)
    state.cachedViews = state.cachedViews.filter((name) =>
      keepNames.includes(name)
    )
  },
  DEL_ALL_VISITED_VIEWS(state) {
    state.visitedViews = state.visitedViews.filter((v) => v.affix)
  },
  DEL_ALL_CACHED_VIEWS(state) {
    const keepNames = state.visitedViews.map((v) => v.name)
    state.cachedViews = state.cachedViews.filter((name) =>
      keepNames.includes(name)
    )
  },
  UPDATE_VISITED_VIEW(state, view) {
    for (const v of state.visitedViews) {
      if (v.path === view.path) {
        v.fullPath = view.fullPath
        v.query = view.query || {}
        v.params = view.params || {}
        break
      }
    }
  },
}

const actions = {
  addView({ commit }, view) {
    commit('ADD_VISITED_VIEW', view)
    commit('ADD_CACHED_VIEW', view)
  },
  delView({ commit, state }, view) {
    return new Promise((resolve) => {
      commit('DEL_VISITED_VIEW', view)
      commit('DEL_CACHED_VIEW', view)
      resolve([...state.visitedViews])
    })
  },
  delOthersViews({ commit, state }, view) {
    return new Promise((resolve) => {
      commit('DEL_OTHERS_VISITED_VIEWS', view)
      commit('DEL_OTHERS_CACHED_VIEWS', view)
      resolve([...state.visitedViews])
    })
  },
  delAllViews({ commit, state }) {
    return new Promise((resolve) => {
      commit('DEL_ALL_VISITED_VIEWS')
      commit('DEL_ALL_CACHED_VIEWS')
      resolve([...state.visitedViews])
    })
  },
  updateVisitedView({ commit }, view) {
    commit('UPDATE_VISITED_VIEW', view)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
